import tw from 'tailwind-styled-components'

export const TwMainContainer = tw.div`
  z-2000 absolute top-0 left-0 w-100vw h-100vh bg-main-old
`

export const TwFullscreenContainer = tw.div`
  border-0
  border-t-1
  border-split-old
  border-solid
  mt-64
  overflow-y-auto
`

export const TwEditorContainer = tw.div`
  overflow-y-auto
  overflow-x-hidden
`
